import React, { useState, useEffect, ReactNode } from "react";
import { StyledHeader } from "./ClubFinancial";
import LabelText from "../../../ui/LabelText";
import { IplayerTrading } from "../../../types/IClubDetail";
import { IFinancialChartData } from "../../../types/IClubDetail";
import FinancialBarchart from "./FinancialBarchart";
import { IFinancialPlayerTransfer } from "../../../types/IClubDetail";
import styled from "styled-components";

interface ClubPlayerTradingProps {
  data: IplayerTrading | undefined;
  transferData: IFinancialPlayerTransfer[];
  seasonData: any[];
  onChange?: (value: string) => void;
  seasonLabel: string;
}
interface PlayerInfo {
  image: string;
  name: string;
  position?: string;
}

interface PlayerDataRow {
  Player: PlayerInfo;
  Age: number;
  Season: string;
  From: PlayerInfo;
  Nationality: string;
  "Transfer fee": string;
}

export const PlayerImage = styled.div`
  border: 1px solid ${({ theme }) => theme.borderColor};
  cursor: pointer;
`;

const ClubPlayerTrading: React.FC<ClubPlayerTradingProps> = ({ data, transferData, seasonData, onChange, seasonLabel }) => {

  const [financialChartData, setFinancialChartData] = useState<IFinancialChartData[]>([]);

  useEffect(() => {
    setFinancialChartData([
      {
        name: "Total revenues ",
        value: data?.playerTradingRevenues,
        valueText: data?.playerTradingRevenuesText,
        color: "#4AF075",
        type: "revenue",
      },
      { name: "Total costs", value: data?.playerTradingCosts, valueText: data?.playerTradingCostsText, color: "#FF7900", type: "cost" },
      {
        name: "Profit",
        value: data?.playerTradingNetProfit,
        valueText: data?.playerTradingNetProfitText,
        color: "#C9F0B5",
        type: "profit",
      },
    ]);
  }, [data]);


  return (
    <>
      <StyledHeader className="header-content player-trading-head">
        <LabelText className="drawer-title">Player Trading</LabelText>
      </StyledHeader>
      <FinancialBarchart data={financialChartData} />
    
    </>
  );
};

export default ClubPlayerTrading;
